/**
 * @Description 门店情况基本信息卡片
 */
// import IconFont from '@/common/components/IconFont';
import { Col, Row, Typography } from 'antd';
import styles from './index.module.less';
import React, { useEffect, useState } from 'react';

const { Text } = Typography;
interface StoreInfoCardV2Props {
  list: any;
}

const imgs = [
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/youth_store_icon1.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/youth_store_icon2.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/youth_store_icon3.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/youth_store_icon4.png`,
];

const StoreInfoCardV2: React.FC<StoreInfoCardV2Props> = ({
  list,
}) => {
  const [tabData, setTabData] = useState<any>([]);

  const init = () => {
    if (list && list.length) {
      if (list.length > 4) {
        list = list.slice(0, 4);
      }

      setTabData(list);
    }
  };

  useEffect(() => {
    init();
  }, [list]);

  return (
    <>
      {tabData && tabData.length > 0 && (
        <div className={styles.storeInfoContentWrap}>
          <div>
            <Row gutter={[8, 10]}>
              {tabData.map((item, index) => (
                <Col span={6} key={index}>
                  <div className={styles.info}>
                    <div className={styles.infoLeftContent}>
                      <div className={styles.count}>{item.count > 0 ? item.count : '-'}</div>
                      {/* <div className={styles.name}>{item.name}</div> */}
                      <Text
                        style={{ width: 60 }}
                        ellipsis={{ tooltip: item.name }}>
                        <span className={styles.name}>{item.name}</span>
                      </Text>
                    </div>
                    <div className={styles.infoRightContent}>
                      <img className={styles.icon} src={imgs[index]} />
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      )}
    </>
  );
};

export default StoreInfoCardV2;
